import React, { useState, useContext } from 'react'
import styles from './DetalleSubPreguntaDJ.module.css'
import GeneralContext from "../../context/GeneralContext"
import * as Funciones from "../../utils/funciones"
import * as Constantes from "../../utils/constantes"
import Modal from '../Modals/Modal'
import btnEliminar from '../../img/btneliminar.png'

const DetalleSubPreguntaDJ = ({ state, setState, tipo }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]

    const [mostrarModal, setModal] = useState(false)
    const textos = ['¡Alerta!', 'Ha ingresado el máximo de países permitidos.']

    const mostrarPopup = () => {
        setModal(true)
    }

    const handleDetalleUno = (e, campo, campoValida) => {
        let valor = Funciones.obtenerAlphanumerico(e.target.value)

        setState((state) => {
            return {
                ...state,
                detalle1: {
                    [campo]: valor
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campoValida]: true
                }
            }
        })
    }

    const cambiarValor = (valor, campo, index, campoValida) => {
        let detalles = state.detalle2
        detalles[index][campo] = valor

        if (campoValida !== undefined) {
            let campoValidacion = state.campoValidado[campoValida]
            campoValidacion[index] = true
            setState((state) => {
                return {
                    ...state,
                    detalle2: detalles,
                    campoValidado: {
                        ...state.campoValidado,
                        [campoValida]: campoValidacion
                    }
                }
            })
        } else {
            setState((state) => {
                return {
                    ...state,
                    detalle2: detalles
                }
            })
        }
    }

    const handleChangePais = (e, campo, index) => {
        let valor = e.target.value
        cambiarValor(valor !== 0 ? valor : null, campo, index, campo)
    }

    const handleChangeNit = (e, campo, index) => {
        let valor = Funciones.obtenerAlphanumerico(e.target.value)
        cambiarValor(valor, campo, index)
    }

    const handleChangeNoNit = (e, campo) => {
        let valor = e.target.value
        
        setState((state) => {
            return {
                ...state,
                [campo]: parseInt(valor),
                noTieneNITDesc: parseInt(valor) === 1 ? null : state.noTieneNITDesc,
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeDescNoNit = (e, campo) => {
        let valor = e.target.value
        let capital = Funciones.sentenceCase(valor)
        
        setState((state) => {
            return {
                ...state,
                [campo]: capital,
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleAgregar = () => {
        let nuevoDetalle = state.detalle2
        nuevoDetalle.push({
            pais: null,
            NIT: null
        })

        setState((state) => {
            return {
                ...state,
                detalle2: nuevoDetalle
            }
        })
    }

    const handleEliminar = (index) => {
        const detalles = state.detalle2
        detalles.splice(index, 1)

        setState((state) => {
            return {
                ...state,
                detalle2: detalles
            }
        })
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <React.Fragment>
            {tipo === 1 ?
                <React.Fragment>
                    <div className={styles.contenedorA}>
                        <label>Número de identificación tributaria /SSN o EIN2</label>
                        <input
                            className={!state.campoValidado.NIT1 ? styles.errorInput : ''}
                            type='text'
                            placeholder='Ingrese número'
                            value={state.detalle1.NIT !== null ? state.detalle1.NIT : ''}
                            onChange={(e) => handleDetalleUno(e, 'NIT', 'NIT1')}
                            maxLength={15}
                            disabled={Deshabilitar() !== true ? false : true}
                        />
                        {!state.campoValidado.NIT1 ? 
                            <span className={styles.error}>Ingrese el número de identificación tributaria</span>
                            : null
                        }
                    </div>
                </React.Fragment>
                : null
            }
            {tipo === 2 ?
                <React.Fragment>
                    {state.detalle2.map((detalle, index) => {
                        return (
                            <div key={index} className={styles.contenedorB}>
                                <div className={styles.tieneNit}>
                                    <div className={styles.paises}>
                                        <label>País(es)</label>
                                        <select
                                            className={state.campoValidado.pais.length > 0 && (state.campoValidado.pais[index] !== undefined && !state.campoValidado.pais[index]) ?
                                                styles.errorSelect : ''}
                                            value={detalle.pais !== null ? detalle.pais : 0}
                                            onChange={(e) => handleChangePais(e, 'pais', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                        >
                                            <option value={0}>Seleccione</option>
                                            {Funciones.obtenerTablasMaestras(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_PAISES).map(pais => (
                                                <option key={pais.id} value={pais.valor}>
                                                    {pais.valor}
                                                </option>
                                            ))}
                                        </select>
                                        {state.campoValidado.pais.length > 0 && (state.campoValidado.pais[index] !== undefined && !state.campoValidado.pais[index]) ? 
                                            <span className={styles.error}>Seleccione un país</span>
                                            : null
                                        }
                                    </div>
                                    <div className={styles.nit}>
                                        <label>NIT(Número tributario)</label>
                                        <input
                                            type='text'
                                            placeholder='Ingrese número'
                                            value={detalle.NIT !== null ? detalle.NIT : ''}
                                            onChange={(e) => handleChangeNit(e, 'NIT', index)}
                                            maxLength={15}
                                            disabled={Deshabilitar() !== true ? false : true}
                                        />
                                    </div>
                                    {state.detalle2.length !== 1 &&
                                        <div className={styles.eliminar}>
                                            <img
                                                className={styles.btnEliminar}
                                                src={btnEliminar}
                                                alt=''
                                                onClick={() => handleEliminar(index)}
                                                style={{pointerEvents: Deshabilitar() === true ? 'none' : 'auto'}}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })}
                    <div className={styles.noTieneNit}>
                        <label className={styles.labelNit}>Si no tiene NIT marque la razón que corresponda:</label>
                        <div className={styles.razones}>
                            <label className={styles.labelRadio}>
                                <input
                                    type="radio"
                                    name="noNit"
                                    value={1}
                                    selected={state.noTieneNIT !== 0 && state.noTieneNIT === 1}
                                    checked={state.noTieneNIT === 1}
                                    onChange={(e) => handleChangeNoNit(e, 'noTieneNIT')}
                                    disabled={Deshabilitar() !== true ? false : true}
                                />
                                <span className={styles.optionRazon}>
                                    El país de residencia fiscal/tributaria no emite NIT (número tributario)
                                </span>
                            </label>
                            <label className={styles.labelRadio}>
                                <input
                                    type="radio"
                                    name="noNit"
                                    value={2}
                                    selected={state.noTieneNIT !== 0 && state.noTieneNIT === 2}
                                    checked={state.noTieneNIT === 2}
                                    onChange={(e) => handleChangeNoNit(e, 'noTieneNIT')}
                                    disabled={Deshabilitar() !== true ? false : true}
                                />
                                <span className={styles.optionRazon}>
                                    El titular no puede obtener un NIT o número equivalente (explicar)
                                </span>
                            </label>
                            {!state.campoValidado.noTieneNIT ? 
                                <span className={styles.error}>Ingresar NIT o marcar una razón si no tiene NIT</span>
                                : null
                            }
                        </div>
                        {state.noTieneNIT === 2 &&
                            <div className={styles.explicacion}>
                                <input
                                    className={!state.campoValidado.noTieneNITDesc ? styles.errorInput : ''}
                                    type='text'
                                    placeholder='Ingrese explicación'
                                    value={state.noTieneNITDesc !== null ? state.noTieneNITDesc : ''}
                                    onChange={(e) => handleChangeDescNoNit(e, 'noTieneNITDesc')}
                                    maxLength={50}
                                    disabled={Deshabilitar() !== true ? false : true}
                                />
                                {!state.campoValidado.noTieneNITDesc ? 
                                    <span className={styles.error}>Debe ingresar una explicación</span>
                                    : null
                                }
                            </div>
                        }
                        {state.detalle2.length === 1 &&
                            <div className={styles.añadir}>
                                <button
                                    className={Deshabilitar() !== true ? styles.insertar : styles.insertarOculto}
                                    onClick={state.detalle2.length > 1 ? () => mostrarPopup() : handleAgregar}
                                >
                                    <span>+</span>
                                    Agregar
                                </button>
                            </div>
                        }
                    </div>
                </React.Fragment>
                : null
            }
            <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} />
        </React.Fragment>
    )
}

export default DetalleSubPreguntaDJ